import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "menu",
  class: "bc-1"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "border bc-sub-2" }, null, -1)
const _hoisted_3 = { class: "menu-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "menu-list-inner"
}
const _hoisted_6 = ["onClick"]

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import $ from 'jquery'
import SettingPanel from '@/components/common/SettingPanel.vue'
import { useInitDataStore } from '@/stores/initDataStore'
import { LayoutInfoMenuIcon } from '@/models/initData/LayoutInfo'


export default /*#__PURE__*/_defineComponent({
  props: {
  isOpen: Boolean,
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props





const initDataStore = useInitDataStore()
const router = useRouter()

const menus = computed(() => {
  return initDataStore.headerMenus.filter(menu => menu.enable)
})

const toggleMenuList = (menu: LayoutInfoMenuIcon, e: MouseEvent) => {
  const $elm = $(e?.target as HTMLElement)
  $elm.toggleClass('open')

  if ($elm.hasClass('open')) {
    $elm.parent().height(50 + 30 * menu.items.length)
  } else {
    $elm.parent().height(50)
  }
}

const handleMenuClick = (menu: LayoutInfoMenuIcon, e: MouseEvent) => {
  if (!menu.event) {
    return toggleMenuList(menu, e)
  }

  menu.event.forEach(event => {
    if (event.function === 'transition_link') {
      let link = event.args.link
      const params = event.args.args

      if (params) {
        let query = [] as string[]

        Object.keys(params).forEach(key => {
          query.push(`${key}=${params[key]}`)
        })

        link += `?${query.join('&')}`
      }

      if (event.args.directLink) {
        window.open(link, '_blank')
      } else {
        router.push(link)
      }
    }
  })
}

const close = () => {
  emit('close')
}

const rootClass = computed(() => {
  return { open: props.isOpen }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu-wrapper", _unref(rootClass)])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "controls bc-2" }, [
        _createElementVNode("div", {
          onClick: close,
          class: "btn-close"
        })
      ]),
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menus), (menu, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: _normalizeClass([[`menu-list-item-${menu.icon}`, menu.items ? 'menu-list-item-has-child' : ''], "menu-list-item"])
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (handleMenuClick(menu, $event))
            }, _toDisplayString(menu.title), 9, _hoisted_4),
            (menu.items)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.items, (menuChild, index2) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index2,
                      class: "menu-list-inner-item"
                    }, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (handleMenuClick(menuChild, $event))
                      }, _toDisplayString(menuChild.title), 9, _hoisted_6)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _createVNode(SettingPanel)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (__props.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: close,
              class: "bg"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})